import React, { useState, useRef, lazy, useEffect, Suspense } from "react";
import { alert_error, alert_success } from "../AppContext.js";
import QRCode from "qrcode.react";
import axios from 'axios';
import { Cookies } from '../index.js';
import Bannerprofile from '../shop/ads/Bannerprofile.jsx';
import { useParams, useNavigate } from 'react-router-dom';
import { RingLoader } from "react-spinners";
import AdModal from '../app_structure/AdModal_deposit.jsx';
import { Helmet } from "react-helmet";
import { update_users_status } from '../order/orders/actions.js';
import { useDispatch } from 'react-redux';
const LazyReCAPTCHA = lazy(() => import("../app_structure/LazyReCAPTCHA"));
function Donate() {
  const navigate = useNavigate();
  function switch_router(link) {
    navigate(link);
  };
  const dispatch = useDispatch();
  const set_users_status = (value) => {
    dispatch(update_users_status(value));
  };
  const { slug_2 } = useParams();
  const { id_cash } = useParams();
  const [nutxuly, setnutxuly] = useState(0);
  const [info, setInfo] = useState("ok");
  const [databank, setdatabank] = useState(null);
  const [success, setsuccess] = useState(false);
  const [site_ten_momo, setSiteTenMomo] = useState("Nguyễn Đăng Tín");
  const [magiaodich, setmagiaodich] = useState(null);
  const [showcaptcha, setshowcaptcha] = useState(false);
  const [nutorder, setnutorder] = useState(null);
  const [maqrcode, setmaqrcode] = useState(null);
  const [trading_amount, set_trading_amount] = useState('');
  const [macode, setmacode] = useState('Vô app momo chuyển cho tớ là Coins lên liền nhé =D');
  const qrCodeStyle = {
    backgroundColor: "#ff69b4",
  };
  const [isDivVisible, setIsDivVisible] = useState(true);
  const recaptchaRef = React.createRef();
  useEffect(() => {
    laythongtin();
    laymanap();
  }, []);
  const intervalIdRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      laymaqr();
    }, 300);
    intervalIdRef.current = setInterval(checknaptien, 5700);
    // Xóa bỏ setInterval khi component unmount
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, [databank, magiaodich]);
  function laymaqr() {
    console.log(123);
    if (databank && magiaodich) {
      if (slug_2 == 'momo') {
        axios.get('https://hust.media/api/wallet/qr_momo.php', {
          params: {
            sotiennap: '20000',
            manaptien: magiaodich,
            stk: databank.stk
          }
        })
          .then(response => {
            // Xử lý phản hồi thành công
            console.log(response.data);
            setmaqrcode(response.data);
          })
          .catch(error => {
            // Xử lý lỗi
            alert_error(error);
          });
      } else if (slug_2 == 'acb') {
        axios.post('https://api.vietqr.io/v2/generate', {
          accountNo: databank.stk,
          accountName: databank.tentk,
          acqId: databank.acqId,
          addInfo: magiaodich,
          amount: trading_amount,
          template: 'compact'
        })
          .then(response => {
            // Xử lý phản hồi thành công
            console.log(response.data);
            setmaqrcode(response.data.data.qrCode);
          })
          .catch(error => {
            // Xử lý lỗi
            alert_error(error);
          });
      } else if (slug_2 == 'me') {
        const username = Cookies.get('username');
        setmaqrcode(username);
      }
      else {
        axios.post('https://api.vietqr.io/v2/generate', {
          accountNo: databank.stk,
          accountName: databank.tentk,
          acqId: databank.acqId,
          addInfo: magiaodich,
          amount: trading_amount,
          template: 'compact'
        })
          .then(response => {
            // Xử lý phản hồi thành công
            console.log(response.data);
            setmaqrcode(response.data.data.qrCode);
          })
          .catch(error => {
            // Xử lý lỗi
            alert_error(error);
          });
      }
    }

  }
  function checknaptien() {
    const myCookieValue = Cookies.get('apikey');
    // Gửi yêu cầu GET bằng Axios
    axios.get('https://hust.media/api/wallet/deposit_check.php?apikey=' + myCookieValue + '&trading_code=' + magiaodich)
      .then(response => {
        if (response.data.status != 1) {
          console.log(response.data);
        }
        else {
          clearInterval(intervalIdRef.current);
          alert_success(response.data.message);
          Cookies.set('users_status', '1');
          set_users_status('1');
          setTimeout(() => {
            setsuccess(true);
          }, 700);
        }
      })
      .catch(error => {
        // Xử lý lỗi
        console.error(error);
      });
  }
  function laymanap() {
    const myCookieValue = Cookies.get('apikey');
    axios.get('https://hust.media/api/wallet/deposit_start.php', {
      params: {
        apikey: myCookieValue,
        service: slug_2,
        id_cash: id_cash
      }
    })
      .then(response => {
        // Xử lý phản hồi thành công
        console.log(response.data);
        const info = response.data;
        setnutorder(response.data.nutorder);
        if (response.data.status != 1) {
          alert_error(response.data.message);
        }
        else {
          alert_success(response.data.message);
          setmagiaodich(response.data.trading_code);
          console.log(response.data.trading_code);
          if (response.data.trading_amount != '') {
            set_trading_amount(response.data.trading_amount);
          }
        }
        if (info.redirect != null && info.redirect != '') {
          setTimeout(function () {
            // Chuyển hướng sang trang web khác
            switch_router(info.redirect);
          }, 200);
        }
      })
      .catch(error => {
        // Xử lý lỗi
        alert_error("lỗi" + error);
      });
  };
  const laythongtin = async () => {
    const username = Cookies.get('username');
    axios.get('https://kotlin.tecom.pro/app/bank_info')
      .then(response => {
        // Xử lý phản hồi thành công
        const result = response.data[0][slug_2];
        if (slug_2 == 'me') {
          result.stk = username;
          console.log(result);
          setdatabank(result);
        } else {
          setdatabank(result);
        }
      })
      .catch(error => {
        // Xử lý lỗi
        alert_error(error);
      });
  }
  function copyText(value) {
    alert_success("Đã sao chép");
    window.saochepnative(value);
  }
  const handleToggle = () => {
    setIsDivVisible(!isDivVisible);
  };
  const inputRef = useRef(null);

  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;

    setnutxuly(0);

    if (status == 1) {
      alert_success(message);
      setnutorder('Cảm ơn bạn đã ủng hộ');

    }
    else if (status == 0) {
      setnutorder(message);
      alert_error(message);
    }
    else {
      setnutorder('Đã xảy ra lỗi vui lòng nhập lại');
      alert_error('Đã xảy ra lỗi vui lòng nhập lại');
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  const handleClick = () => {
    if (inputRef.current) {

      const inputValue = inputRef.current.value;
      if (inputValue) {
        inputRef.current.disabled = true;
        setshowcaptcha(true);
        setnutorder('Hãy tích vào ô tôi không phải người máy')
        console.log("Giá trị đã nhập:", inputValue);
        setmacode(inputValue);
      }
      else {
        alert_error('Chưa nhập gì');
      }
    }
  };
  const [showAd, setShowAd] = useState(true);
  const handleCloseAd = () => {
    setShowAd(false);
    // switch_router('/reactapp/');
  };
  return (
    <div className="container-fluid mt-7">
      {
        success &&
        (<>
          <AdModal isOpen={showAd} onClose={handleCloseAd} switch_router={switch_router} className="mx-auto" />
        </>)
      }
      <Helmet>
        <title>Donate Hust Media</title>
      </Helmet>
      <div className="row">
        <div className="col-xl-7 mb-5 mb-xl-0">
          <div className="card card-profile shadow">
            <div className="card-header border-0">
              <div className="row align-items-center">
                {!databank || !magiaodich ? (
                  <div className="container-fluid">

                    <div className="row" style={{ backgroundColor: "#FFB6C1" }}>
                      <p className="text-center" style={{ color: "#fff" }}>
                        <div
                          className="text-center spinner-border"
                          role="status"
                        ></div>
                        <br />
                        Đang tải dữ liệu
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="col">
                    <div className="text-sm text-muted font-medium mb-0">
                      Thông Tin ngân hàng </div>
                    <div className="text-lg text-muted font-medium mb-0 flex items-center justify-between">
                      <div className="flex items-center">
                        <span className="mr-2">{databank.tenbank}</span>
                        <img src={databank.logo} className="w-16 h-auto" alt="Logo" />
                      </div>
                      <div className="ml-2 text-base">{databank.tentk}</div>
                    </div>


                    <ul className="pl-4 mt-2 space-y-3">
                      <li className="flex items-center">
                        <span className="mr-1 text-pink-500 font-medium">
                          Số Tài Khoản:
                        </span>
                        <input
                          type="text"
                          className="form-control border-pink-600"
                          value={databank.stk}
                          id="input1"
                          readOnly
                        />
                        <button
                          onClick={() => copyText(databank.stk)}
                          className="ml-2 group rounded-2xl h-15 w-48 bg-pink-300 font-bold text-lg text-white relative overflow-hidden"
                        >
                          <span className="text-base">
                            <b>Sao chép</b>
                          </span>
                          <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                        </button>
                      </li>
                      <li className="flex items-center">
                        <span className="mr-1 text-pink-500 font-medium">
                          Nội dung chuyển tiền:
                        </span>
                        <input
                          type="text"
                          className="form-control border-pink-600"
                          value={magiaodich}
                          id="input1"
                          readOnly
                        />
                        <button
                          onClick={() => copyText(magiaodich)}
                          className="ml-2 group rounded-2xl h-15 w-48 bg-pink-300 font-bold text-lg text-white relative overflow-hidden"
                        >
                          <span className="text-base">
                            <b>Sao chép</b>
                          </span>
                          <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                        </button>
                      </li>
                      {
                        trading_amount &&
                        (<>
                          <li className="flex items-center">
                            <span className="mr-1 text-pink-500 font-medium">
                              Số tiền chuyển:
                            </span>
                            <input
                              type="text"
                              className="form-control border-pink-600"
                              value={trading_amount}
                              id="input1"
                              readOnly
                            />
                            <button
                              onClick={() => copyText(trading_amount)}
                              className="ml-2 group rounded-2xl h-15 w-48 bg-pink-300 font-bold text-lg text-white relative overflow-hidden"
                            >
                              <span className="text-base">
                                <b>Sao chép</b>
                              </span>
                              <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                            </button>
                          </li>
                        </>)
                      }
                    </ul>
                    <li className="flex items-center mt-2">
                      <span className="mr-3 text-pink-500 font-medium">
                        Trạng thái:
                      </span>
                      <button className="group rounded-2xl h-12 w-55 bg-pink-300 font-bold text-base text-white relative overflow-hidden">
                        {nutxuly == 0 && (<span className="spinner-border spinner-border-sm"></span>)}
                        &ensp;{nutorder}
                        <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                      </button>
                    </li>
                    {
                      window.location.href.includes('block') ? (<>
                        <h3 className="text-lg text-muted font-medium mt-2">
                          HƯỚNG DẪN MỞ KHÓA
                        </h3>
                        <ol className="list-decimal list-inside pl-4">
                          <li className="text-sm mb-0">
                            Bước 1 : Chuyển tối thiểu 1k Coins hoặc 1k vnđ
                          </li>
                          <li className="text-sm mb-0">
                            Bước 2 : Đợi vài giây để mở khóa
                          </li>
                          <li className="text-sm font-normal">
                            ✨💖 App rất vui vì sự thông cảm của bạn ✨
                          </li>

                        </ol>
                      </>) :
                        (<>
                          <h3 className="text-lg text-muted font-medium mt-2">
                            HƯỚNG DẪN NẠP TIỀN {slug_2}
                          </h3>
                          <ol className="list-decimal list-inside pl-4">
                            <li className="text-sm mb-0">
                              Bước 1 : Chuyển tiền với nội dung như trên
                            </li>
                            <li className="text-sm mb-0">
                              Bước 2 : Đợi vài giây để tự động nạp tiền
                            </li>
                            <li className="text-sm font-normal">
                              ✨💖 Mã nạp không đổi 🔄, nhận đủ 🌟 khi chuyển tiếp nhiều lần ✨
                            </li>

                          </ol>
                        </>)
                    }


                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {databank && magiaodich && (

          <div className="col-xl-5 mb-3">
            <div className="card card-profile shadow rounded-lg border-0">
              {
                !maqrcode ? (<div className="flex justify-center items-center">
                  <RingLoader size={80} color="#0000ff" />{" "}
                </div>
                ) : (
                  <div className="card-body py-0 py-md-2">
                    <h5 className="bold mb-0 text-base text-pink-500">
                      Nạp bằng QR Code
                    </h5>
                    <div className="d-flex justify-content-center mb-2 mt-1">
                      {info == null ? (
                        <div
                          className="text-center spinner-border"
                          role="status"
                        ></div>
                      ) : (
                        <>
                          {slug_2 == 'momo' ? (
                            <>
                              <img
                                src={'data:image/png;base64,' + maqrcode}
                                alt="qrcode"
                                className="w-72 mb-1 object-cover rounded-lg shadow-md"
                              />
                            </>
                          ) :
                            (
                              <QRCode
                                includeMargin="true"
                                fgColor="#FFFFFF"
                                bgColor="#ff69b4"
                                size={256}
                                renderAs="svg"
                                style={qrCodeStyle}
                                value={maqrcode}
                              />
                            )}
                        </>
                      )}

                    </div>
                    {isDivVisible && (
                      <>   </>)}

                  </div>)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Donate;
